import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice";
import { GoodsItem } from "@/domains/shop/constants/goodsItem";

type Props = {
  item: GoodsItem;
  children: ReactNode;
};

export default function ShopGoodsCard({ item, children }: Props) {
  const { t } = useTranslation("shop");
  const { title, text, price, weight, image } = item;
  return (
    <div
      className="flex flex-col p-5 bg-dark-800 rounded-[0.75rem]"
      style={{ width: "calc(33.3333% - 0.25rem)" }}
    >
      <div className="relative flex flex-wrap w-full h-[9.375rem] bg-[url(/svg/shop/dots.svg)] bg-center bg-no-repeat">
        <img
          src={image}
          alt="goods"
          className="absolute z-1 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        />
        <div className="relative z-2 flex items-center w-full mb-auto">
          <p className="ml-auto text-10 font-extrabold uppercase">
            <span className="text-11 font-bold text-accent-solid">{weight}</span>{" "}
            {t("values.weight")}
          </p>
        </div>
      </div>
      <p className="mb-2.5 text-16 font-medium">{title}</p>
      <p
        className="mb-4 h-9 text-15 font-medium opacity-60 overflow-hidden"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: "2",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
        }}
      >
        {text}
      </p>
      <p className="mb-5 text-16 font-bold text-accent-solid">{formatPrice(price)}₽</p>
      {children}
    </div>
  );
}
